import { AiChatMessageDto, AiMessageKindEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

// Knowledge / QuickReply / null pass through (already in driver's language).
// Generic kinds map to portal i18n so an employee reading the conversation sees them in their own language.
export function aiMessageContentFilter(msg: AiChatMessageDto): string {
  switch (msg.kind) {
    case AiMessageKindEnum.Clarification: return i18n.t(LF.SupportAiMessageClarification) as string;
    case AiMessageKindEnum.NoAnswerHandoff: return i18n.t(LF.SupportAiMessageNoAnswerHandoff) as string;
    case AiMessageKindEnum.Fallback: return i18n.t(LF.SupportAiMessageFallback) as string;
    case AiMessageKindEnum.RateLimit: return i18n.t(LF.SupportAiMessageRateLimit) as string;
    case AiMessageKindEnum.DialogLimit: return i18n.t(LF.SupportAiMessageDialogLimit) as string;
    default: return msg.content ?? '';
  }
}
